<p-drawer 
    header="Nuova richiesta" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    
    <h5>Materiale</h5>
    <div class="grid grid-cols-1">
        <div class="mb-4"><spike-field-wrapper label="Tipo">{{equipmentData()?.shortDescription}}</spike-field-wrapper></div>
        <div class="mb-4"><spike-field-wrapper label="Unità di misura">{{equipmentData()?.unit}}</spike-field-wrapper></div>
    </div>
    <h5>Richiesta</h5>

    <spike-equipment-request-form [isInsert]="true" [form]="form"></spike-equipment-request-form>
    <!--
    <h5>Operazioni bloccate dalla richiesta</h5>
          @for (operation of operations(); track $index) {
            <div class="mb-2 w-full">
                <p-checkbox [inputId]="'op_'+operation.operationId" [name]="'op_'+operation.operationId" [(ngModel)]="operation.selected" [binary]="true"/>
                <label [for]="'op_'+operation.operationId" class="ml-2"> {{operation.shortDescription}} </label>
            </div>
     }
-->
    <ng-template #footer>
        @if(!readonly()){
        <div class="w-full">
            <p-button (click)="onSaveClicked()" [disabled]="form.invalid" icon="pi pi-save" label="Salva" severity="primary" styleClass="w-full"></p-button>
        </div>
        }
    </ng-template>
</p-drawer>
